import { createFileRoute, redirect } from "@tanstack/react-router";

// Courses are not built yet, so the page no longer shows a "coming soon"
// placeholder. Anyone landing here (old links, bookmarks) is sent to the
// Learn Hub, which holds the real self-paced material.
export const Route = createFileRoute("/courses")({
  beforeLoad: () => {
    throw redirect({ to: "/learn" });
  },
});
